import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { CommonService } from '../../../services/common/common.service';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { Constant, PlatFormType, SolrContentTypeValues } from 'src/app/common/constant/constant';
import { LandingpageService } from 'src/app/services/landingpage/landingpage.service';
import { StripeCardsComponent } from 'src/app/components/common/stripe-cards/stripe-cards.component';
import { concatAll } from 'rxjs/operators';
import * as moment from 'moment';
import { ThreadPostService } from '../../../services/thread-post/thread-post.service';
import { BaseService } from 'src/app/modules/base/base.service';
import { NgbModal, NgbModalConfig, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ManageListComponent } from '../../../components/common/manage-list/manage-list.component';
import { RepairOrderService } from 'src/app/services/repair-order/repair-order.service';
@Component({
  selector: 'app-ro-invoice',
  templateUrl: './ro-invoice.component.html',
  styleUrls: ['./ro-invoice.component.scss']
})
export class RoInvoiceComponent implements OnInit {
  @Input() preview: boolean = false;
  @Input() roData: any = '';
  @Input() paymentMethodEnabledFlag: boolean = true;
  @Output() roInvoiceComponentRef: EventEmitter<RoInvoiceComponent> = new EventEmitter();
  @Output() callbackROInvoice: EventEmitter<RoInvoiceComponent> = new EventEmitter();
  @Output() callbackROEInvoice: EventEmitter<any> = new EventEmitter();
  @Output() callbackROPayStatus: EventEmitter<any> = new EventEmitter();
  stripeCardPageRef: StripeCardsComponent;
  public payInvoiceFlag: boolean = false;
  public paymentInvoiceCheckFlag: boolean = false;
  public payCheque: boolean = false;
  public payCash: boolean = false;
  public payCard: boolean = false;
  public payAccount: boolean = false;
  public payOtherAccount: boolean = false;
  public payChequePaid: boolean = false;
  public payChequeUnPaid: boolean = true;
  public roId;
  public itemLimit: any = 20;
  public itemOffset: any = 0;
  public userId;
  public user;
  public domainId;
  public roleId;
  public threadId;
  public emailId;
  public businessRoleId;
  public countryId='';
  public apiData: Object;
  public invoiceCheckList: any = [];
  public invoiceonAccList: any = [];
  public invoiceCardList: any = [];
  public invoiceCashList: any = [];
  public paymentInfoJsonArr: any = [];
  public stripeInfoJsonArr: any = [];
  public showCardItemData: any = [];
  public invoiceOtherAccList: any = [];
  public cardShow: any = [];
  public backNameList: any = []; 
  public bankID: string = '';
  public bankName: string = '';
  public chequeNo: string = '';
  public paymentStatus: string = '';
  public saveROchequeFlag: boolean = true;
  public payButtonShow: boolean = false;
  public isUpdateBankName: boolean = false;
  public editPostUpload: boolean = true;
  public manageAction: string;
  public postEditApiData: object;
  public contentType: number = 91;
  public displayOrder: number = 0;
  public EditAttachmentAction: 'attachments';
  public attachmentItems: any = [];
  public updatedAttachments: any = [];
  public deletedFileIds: any = [];
  public removeFileIds: any = [];
  public mediaUploadItems: any = [];
  public uploadedItems: any = [];
  public attachments: any = [];
  public payAttachments: any = [];
  public uploadContents: any = [];
  public attachmentLoading: boolean = false;
  public pageAccess: string = 'ro-payment-upload';
  public action = "view";
  public totalInvoice: any = 0;
  public estimationTotal: number = 0;
  public invoiceID: number = 0;
  public wdestimationTotal: number = 0;
  public editSection: boolean = false;
  public shopId;
  public estimateId;
  public dispatchId;
  public showCheckMethod: boolean = false;
  public showCashMethod: boolean = false;
  public showCardMethod: boolean = false;
  public showAccountMethod: boolean = false;
  public showOtherMethod: boolean = false;
  public estimateActionType: string = '';
  public estimateActionTypeFlag: boolean = false;
  public paymentDays: string = '';
  public tableHeight: number = 200;
  public loading: boolean = true;
  public cardAction: boolean = true;
  public cardAccess: string = "invoice-manage";
  public shopEmail: string = "";

  public paymentLoading: boolean = false;
  public paymentFailurePopup: boolean = false;
  public paymentSuccessPopup: boolean = false;
  public paymentMethod: string = 'card';
  public paymentMessage: string = 'Payment Failed';
  public viewCardDetailPOPUP: boolean = false;
  public paymentSuccessText1 : string = 'ch_346_E34554654654634SFF';
  public paymentSuccessText2: number = 0;
  public paymentSuccessText3 : any = '';
  public paymentSuccessText4 : any = '';
  public paymentSuccessText5 : any = '';

  public collabticApi: string;
  public OtherPaymentItems: any;
  public filteredOtherPaymentIds = [];
  public filteredOtherPayments = [];
  public previewDynamicId = 0;
  public paidFlag: boolean = false;
  public paymentMehodsFlag: boolean = false;

  constructor(private router: Router, private repairOrderApi: RepairOrderService,private config: NgbModalConfig,private modalService: NgbModal,private baseSerivce: BaseService,private threadPostService: ThreadPostService,private LandingpagewidgetsAPI: LandingpageService,private commonApi: CommonService, public apiUrl: ApiService,private authenticationService: AuthenticationService,) {
    config.backdrop = 'static';
    config.keyboard = false;
    config.size = 'dialog-centered';
   }

  ngOnInit(): void {  
    console.log(this.roData);
    this.roId = this.roData.roIdInt;
    this.shopId = this.roData.shopIdInt;
    this.threadId = this.roData.threadIdInt;
    this.dispatchId = this.roData.dispatchIdInt;
    if(this.paymentMethodEnabledFlag) {
      console.log(this.roId);
      console.log(this.shopId);
      console.log(this.threadId);
      console.log(this.dispatchId);
      console.log(this.estimationTotal);
      console.log(this.wdestimationTotal);
      if(!this.preview){
        setTimeout(() => {
          this.roInvoiceComponentRef.emit(this);     
        }, 100);
      }
      this.user = this.authenticationService.userValue;
      this.domainId = this.user.domain_id;
      this.userId = this.user.Userid;
      this.roleId = this.user.roleId;
      this.emailId = this.user.Email;
      if(this.preview){
        this.previewDynamicId = 1;
        setTimeout(() => {
          this.invoiceCardList = []; 
          if(this.roData.stripeInfoJsonArr && this.roData.stripeInfoJsonArr.length>0 && this.roData.paymentInfoJsonArr && this.roData.paymentInfoJsonArr.length>0){
            this.stripeInfoJsonArr = this.roData.stripeInfoJsonArr;
            this.invoiceCardList = this.roData.paymentInfoJsonArr;
            let tdate = this.invoiceCardList[0].transactionDate;
            tdate = moment.utc(tdate).toDate();
            let tdate1 = moment(tdate).local().format('MM/DD/YYYY h:mm:ss A');
            let tdate2 = moment(tdate).local().format('MMM DD, YYYY h:mm A');

            this.invoiceCardList[0].transactionDatePOPUP = tdate1;
            this.invoiceCardList[0].transactionDate = tdate2;

            this.loading = false;
            this.paymentInvoiceCheckFlag = true;  
            this.payInvoiceFlag = false;  
            this.totalInvoice = this.estimationTotal;  
            this.totalInvoice = Math.abs(this.totalInvoice).toFixed(2);
          }  
          else{ 
            this.loadInvoiceDetails('',true);     
          }        
        }, 100);
      } else {
        setTimeout(() => {
          this.roInvoiceComponentRef.emit(this);     
        }, 100);

        this.postEditApiData = {
          access: this.pageAccess,
          pageAccess: this.pageAccess,
          apiKey: Constant.ApiKey,
          domainId: this.domainId,
          countryId: this.countryId,
          userId: this.userId,
          contentType: this.contentType,      
          displayOrder: this.displayOrder,
          uploadedItems: [],
          attachments: [],
          attachmentItems: [],
          updatedAttachments: [],
          deletedFileIds: [],
          removeFileIds: []
        };

        this.collabticApi = Constant.collabticV3ApiUrl;  

        this.commonApi.payROUploadDataReceivedSubject.subscribe((response) => {
          if(response){
            this.callCloseThreadAPI(); 
            this.loadInvoiceDetails();
            this.setCheckEmpty();
          }
        });
      }
    } else {
      this.loading = false;
    }
  }

  loadPage(){

    this.totalInvoice = this.estimateActionType != 'wd' ? this.estimationTotal : this.wdestimationTotal;
    this.totalInvoice = Math.abs(this.totalInvoice).toFixed(2);
    this.getPaymentMethods();  

    setTimeout(() => {
      this.callbackROInvoice.emit(this);
    }, 500);

  }

  tapPayment(type,cardType=''){
    this.payCheque=false;
    this.payCash=false;
    this.payCard=false;
    this.payAccount=false;
    this.payOtherAccount=false;
    switch(type){
      case '1':
        this.payCheque = true;
        this.saveROchequeFlag = false;
      break;
      case '2':
        this.payCash = true;
        this.saveROchequeFlag = false;
      break;
      case '3':
        this.payCard = true;
        this.saveROchequeFlag = this.cardShow && this.cardShow.length>0 ? false : true;
        if(cardType == 'cards'){
          this.saveROchequeFlag = false;
        }
      break;
      case '4':
        this.payAccount = true; 
        this.saveROchequeFlag = this.paymentDays == '' ? true : false;       
      break;
      case '5':
        this.payOtherAccount = true;      
      break;
    }

  }
  payChequeOption(type){
    switch(type){
      case '1':
        this.payChequePaid = true;
        this.payChequeUnPaid = false;
      break;
      case '0':
        this.payChequeUnPaid = true;
        this.payChequePaid = false;
      break;
    }
    
  }
  savePayInvoiceCancel(){
    this.payInvoiceFlag = false;
    this.paymentInvoiceCheckFlag = true;
    //this.loadInvoiceDetails();
    this.setCheckEmpty();
  }
  savePayInvoice(){
    this.saveROcheque();
  }
  loadInvoiceDetails(type='',preview=false){
    if(type==''){
    let formData = new FormData;
    formData.append('apiKey', Constant.ApiKey);
    formData.append('userId', this.userId);
    formData.append('domainId', this.domainId);
    formData.append('roId', this.roId);    
  
    this.commonApi.getROchequelist(formData).subscribe((response) => {
      let dataItems = [];
      if(response.status == 'Success'){
        this.invoiceCashList = [];        
        this.invoiceCheckList = [];
        this.invoiceonAccList = [];
        this.invoiceCardList = [];
        this.invoiceOtherAccList = [];
        dataItems = response.items &&  response.items.length>0 ?  response.items : [];
        if(dataItems && dataItems.length>0){
           let paymentStatus = dataItems[0].paymentStatus == '2' ? 'paid' : 'unpaid';
           let invoiceType = dataItems[0].invoiceType != undefined && dataItems[0].invoiceType != '' ? dataItems[0].invoiceType : 'Price Invoice';
           let dataObj = {
            paymentStatus :paymentStatus,
            invoiceType: invoiceType
           }
           this.callbackROEInvoice.emit(dataObj);
           if(dataItems[0].paymentMethod != 3){           
            switch(dataItems[0].paymentMethod){                
                case 2:  
                  this.paymentInvoiceCheckFlag = true;  
                  this.payInvoiceFlag = false; 
                  this.invoiceonAccList = dataItems;
                   let tdate11 = this.invoiceonAccList[0].createdOn;
                  tdate11 = moment.utc(tdate11).toDate();
                  let tdate22 = moment(tdate11).local().format('MMM DD, YYYY h:mm A');
                  this.invoiceonAccList[0].paidOnDate = tdate22;                    
                break;
                case 4:     
                  this.paymentInvoiceCheckFlag = true;  
                  this.payInvoiceFlag = false;      
                  this.invoiceCheckList = dataItems;
                  this.invoiceCheckList.forEach(items => {
                    items['uploadContents'] = items.uploadContents != undefined ? items.uploadContents : [];
                    items['attachments'] = items.uploadContents;
                    items["attachmentLoading"] = items.uploadContents.length > 0 ? false : true;
                    let tdate11 = this.invoiceCheckList[0].createdOn;
                  tdate11 = moment.utc(tdate11).toDate();
                  let tdate22 = moment(tdate11).local().format('MMM DD, YYYY h:mm A');
                  this.invoiceCheckList[0].paidOnDate = tdate22;
                  });
                break;
                case 5:    
                  this.paymentInvoiceCheckFlag = true;  
                  this.payInvoiceFlag = false;
                  this.invoiceOtherAccList = dataItems;                     
                  let tdate = this.invoiceOtherAccList[0].createdOn;
                  tdate = moment.utc(tdate).toDate();
                  let tdate2 = moment(tdate).local().format('MMM DD, YYYY h:mm A');
                  this.invoiceOtherAccList[0].paidOnDate = tdate2;
                break;
                case 6:  
                  this.paymentInvoiceCheckFlag = true;  
                  this.payInvoiceFlag = false; 
                  this.invoiceCashList = dataItems;  
                  let pdate = this.invoiceCashList[0].createdOn;
                  pdate = moment.utc(pdate).toDate();
                  let pdate2 = moment(pdate).local().format('MMM DD, YYYY h:mm A');
                  this.invoiceCashList[0].paidOnDate = pdate2;                
                break;
            }
          }
          else{
            if(!preview){this.showOneMethod();}
          }
        }  
        else{
          if(!preview){this.showOneMethod();}
          let dataObj = {
            action: 'empty'
          };
          this.callbackROEInvoice.emit(dataObj);

        }      
      }
      else{        
        if(!preview){this.showOneMethod();}
      }

      if(!preview){
        setTimeout(() => {

        this.loading = false;
          
          if(this.payInvoiceFlag){
            this.estimateActionTypeFlag = false;
            if(!this.estimateActionTypeFlag){
              this.totalInvoice = this.estimateActionType == 'retail' ? this.estimationTotal : this.wdestimationTotal;
            }    
            else{
              this.totalInvoice = this.estimationTotal;
            }    
          }
          else{
            this.estimateActionTypeFlag = dataItems.length>0 && dataItems[0].paymentStatus == '2' ? true : false;   
            
            if(!this.estimateActionTypeFlag){
              this.totalInvoice = this.estimateActionType == 'retail' ? this.estimationTotal : this.wdestimationTotal;
            } 
            else{
              this.totalInvoice = dataItems[0].paidAmount != undefined && dataItems[0].paidAmount != null && dataItems[0].paidAmount != '' && dataItems[0].paidAmount != 0 ? dataItems[0].paidAmount : this.estimationTotal;  
            }  
          }
          this.totalInvoice = Math.abs(this.totalInvoice).toFixed(2);

        }, 100);
      }
      else{
         this.loading = false;
      } 

    });
  }
  else{
      this.tapPayment('3',type);       
  }
  }

  showOneMethod(){
    this.payInvoiceFlag = true;
    this.paymentInvoiceCheckFlag = false;
    if(this.showCheckMethod && !this.showCardMethod && !this.showCashMethod && !this.showAccountMethod && !this.showOtherMethod){
      this.tapPayment('1');      
    }
    if(!this.showCheckMethod && !this.showCardMethod && !this.showCashMethod && this.showAccountMethod && !this.showOtherMethod){
      this.tapPayment('4');
    }
    if(!this.showCheckMethod && this.showCardMethod && !this.showCashMethod && !this.showAccountMethod && !this.showOtherMethod){
      this.loading = false;
      this.tapPayment('3');
    }
    if(!this.showCheckMethod && !this.showCardMethod && !this.showCashMethod && !this.showAccountMethod && this.showOtherMethod){
      this.tapPayment('5');
    }
    if(!this.showCheckMethod && !this.showCardMethod && this.showCashMethod && !this.showAccountMethod && !this.showOtherMethod){
      this.tapPayment('2');
    } 
  }

  setCheckEmpty(){
    this.editSection = false;
    this.saveROchequeFlag = true;
    this.bankID = '';
    this.bankName = '';
    this.chequeNo = '';
    this.payCheque=false;
    this.payCash=false;
    this.payCard=false;
    this.payAccount=false;
    this.payOtherAccount=false;
    this.uploadedItems=[];
    this.attachments=[];
    this.payAttachments=[];
    this.attachmentItems=[];
    this.updatedAttachments=[];
    this.deletedFileIds=[];
    this.removeFileIds=[];    
    this.postEditApiData = {
      access: this.pageAccess,
      pageAccess: this.pageAccess,
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      countryId: this.countryId,
      userId: this.userId,
      contentType: this.contentType,      
      displayOrder: this.displayOrder,
      uploadedItems: [],
      attachments: [],
      attachmentItems: [],
      updatedAttachments: [],
      deletedFileIds: [],
      removeFileIds: []
    };
    this.postEditApiData['uploadedItems'] = this.uploadedItems;
    this.postEditApiData['attachments'] = this.uploadedItems;
    this.editPostUpload = false;
    setTimeout(() => {
      this.editPostUpload = true;
    }, 100);
  }

  saveROcheque(){
    if(this.payCheque){
      this.saveROchequeFlag = false;    
    }
    if(this.payAccount){
      this.saveROchequeFlag = this.paymentDays == '' ? true : false;    
    }
    if(this.payOtherAccount){
      this.saveROchequeFlag  = this.filteredOtherPaymentIds && this.filteredOtherPaymentIds.length>0 ? false : true;
    }
    if(this.payCash){
      this.saveROchequeFlag = false;    
    }
    if(!this.saveROchequeFlag){
      let formData = new FormData;
      formData.append('apiKey', Constant.ApiKey);
      formData.append('userId', this.userId);
      formData.append('domainId', this.domainId);
      formData.append('roId', this.roId);  
      //formData.append('paidAmount', this.payChequePaid ? this.totalInvoice.toString() : '0'); 
      formData.append('paidAmount', this.totalInvoice.toString()); 
      formData.append('paymentStatus', this.payChequePaid ? '2' : '1');  
      formData.append('invoiceType', this.estimateActionType == 'retail' ? 'Price Invoice' : 'Cost Invoice');             
      
      if(this.payCard){
        formData.append('paymentMethod', '1');
      }
      if(this.payAccount){
        formData.append('paymentMethod', '2');
        formData.append('onAccountDays', this.paymentDays);        
      }
      if(this.payCheque){
        formData.append('paymentMethod', '4'); 
        formData.append('bankId', this.bankID);    
        formData.append('chequeNo', this.chequeNo);
      }
      if(this.payOtherAccount){
        formData.append('paymentMethod', '5');   
        formData.append('otherPaymentOptionId', this.filteredOtherPaymentIds[0]);       
        formData.append('otherPaymentOptionName', this.filteredOtherPayments[0]);       
      }
      if(this.payCash){
        formData.append('paymentMethod', '6');
      }

      //formData.append('mediaCloudAttachments', JSON.stringify(this.mediaUploadItems));
      if(this.editSection && this.payCheque){
        formData.append('deleteMediaId', JSON.stringify(this.deletedFileIds));
        formData.append('updatedAttachments',  JSON.stringify(this.updatedAttachments));
        formData.append('deletedFileIds',  JSON.stringify(this.deletedFileIds));
        formData.append('removeFileIds',  JSON.stringify(this.removeFileIds));
      }
      
      /*new Response(formData).text().then(console.log);
      return false;*/   
    
      this.commonApi.saveROchequedetails(formData).subscribe((response) => {
      
        if(response.status == 'Success'){
        
          
          if(Object.keys(this.uploadedItems).length > 0 && this.uploadedItems.items.length > 0) {
            this.editPostUpload = false;            
            this.postEditApiData['uploadedItems'] = this.uploadedItems.items;
            this.postEditApiData['attachments'] = this.uploadedItems.attachments;
            this.postEditApiData['message'] = "Upload Successfully";                       
            this.postEditApiData['threadId'] = this.roId;                        
            this.postEditApiData['dataId'] = this.roId;                        
            this.manageAction = 'uploading';
            this.postEditApiData['threadAction'] = 'new';            
            setTimeout(() => {              
              this.editPostUpload = true;
            }, 100);
          }

          else{
            if(this.payCard){}
            else{                          
              this.callCloseThreadAPI(); 
              this.loadInvoiceDetails();
              this.setCheckEmpty();
            }
          }
          
        }
      });
    }
  }

  showBankData(name='',id=''){
    let formData = new FormData;
    formData.append('apiKey', Constant.ApiKey);
    formData.append('userId', this.userId);
    formData.append('domainId', this.domainId);
    formData.append('limit', "0");    
    formData.append('offset', "20");  
    this.commonApi.getRObankslist(formData).subscribe((response) => {    
      this.backNameList=[]; 
      this.bankID = '';
      if(response.status == 'Success'){
        this.backNameList = response.items;
        if(name !=''){
          this.backNameList.forEach(bn => {
            if(name == bn.name){
              this.bankID = bn.id;
            }
            if(id == bn.id){
              this.bankID = bn.id;
            }
          });
        }       
      }
      setTimeout(() => {
        let nameList  = {
          id : '0',
          name : 'New'
        }
        this.backNameList.unshift(nameList);
      }, 100);
      
    });
  }

  serviceAction(type,item=''){
     this.isUpdateBankName = true;
     this.bankID = '';
     this.bankName = '';
     this.showBankData('', '00');
  }

saveBtn(){
  let formData = new FormData;
    formData.append('apiKey', Constant.ApiKey);
    formData.append('userId', this.userId);
    formData.append('domainId', this.domainId);
    formData.append('name', this.bankName);    
    //formData.append('id', "");  
    this.commonApi.saveRObankName(formData).subscribe((response) => {    
      this.backNameList=[]; 
      this.isUpdateBankName = false;
      if(response.status == 'Success'){
        this.showBankData(this.bankName);
      }
    });
  }

    // Attachment Action
    attachmentAction(data) {
      console.log(data)
      let action = data.action;
      let fileId = data.fileId;
      let caption = data.text;
      let url = data.url;
      let lang = data.language;
      switch (action) {
        case 'file-delete':
          this.deletedFileIds.push(fileId);
          break;
        case "file-remove":
          this.removeFileIds.push(fileId);
          break;
        case 'order':
          let attachmentList = data.attachments;
          for(let a in attachmentList) {
            let uid = parseInt(a)+1;
            let flagId = attachmentList[a].flagId;
            let ufileId = attachmentList[a].fileId;
            let caption = attachmentList[a].caption;
            let uindex = this.updatedAttachments.findIndex(option => option.fileId == ufileId);
            if(uindex < 0) {
              let fileInfo = {
                fileId: ufileId,
                caption: caption,
                url: (flagId == 6) ? attachmentList[a].url : '',
                displayOrder: uid
              };
              this.updatedAttachments.push(fileInfo);
            } else {
              this.updatedAttachments[uindex].displayOrder = uid;
            }
          }
          break;
        default:
          let updatedAttachmentInfo = {
            fileId: fileId,
            caption: caption,
            url: url,
            language: lang
          };
          let index = this.updatedAttachments.findIndex(option => option.fileId == fileId);
          if(index < 0) {
            updatedAttachmentInfo['displayOrder'] = 0;
            this.updatedAttachments.push(updatedAttachmentInfo);
          } else {
            this.updatedAttachments[index].caption = caption;
            this.updatedAttachments[index].url = url;
            this.updatedAttachments[index].language = lang;
          }
  
          console.log(this.updatedAttachments)
          break;
      }
  
    }

  editAttachments(items) {  
    if(items.action == 'insert') {
      let minfo = items.media;
      let mindex = this.attachmentItems.findIndex(option => option.fileId == minfo.fileId);
      if(mindex < 0) {
        this.attachmentItems.push(minfo);
        this.editPostUpload = false;
        setTimeout(() => {
          this.editPostUpload = true;
        }, 10);
        let dindex = this.deletedFileIds.findIndex(option => option == minfo.fileId);
        if(dindex >= 0) {
          this.deletedFileIds.splice(dindex, 1);
          this.deletedFileIds = this.deletedFileIds;
        }
        let rindex = this.removeFileIds.findIndex(option => option.fileId == minfo.fileId);
        if(rindex >= 0) {
          this.removeFileIds.splice(rindex, 1);
          this.removeFileIds = this.removeFileIds;
        }
      }
    } else if(items.action == 'remove') {
      let rmindex = this.attachmentItems.findIndex(option => option.fileId == items.media);
      this.attachmentItems.splice(rmindex, 1);
      this.editPostUpload = false;
        setTimeout(() => {
          this.editPostUpload = true;
        }, 10);
      this.deletedFileIds.push(items.media);
    } else {
      this.uploadedItems = items;
    }   

    console.log(this.uploadedItems)
    console.log(this.attachmentItems)

    /*apiData.append('deleteMediaId', JSON.stringify(this.deletedFileIds));
    apiData.append('updatedAttachments',  JSON.stringify(this.updatedAttachments));
    apiData.append('deletedFileIds',  JSON.stringify(this.deletedFileIds));
    apiData.append('removeFileIds',  JSON.stringify(this.removeFileIds));*/ 

   
     
  }
  editPayInvoice(){  

    this.editSection = true;
    this.payInvoiceFlag = true;

    if(this.invoiceCheckList && this.invoiceCheckList.length>0){
      this.payCheque = true;      
      this.paymentInvoiceCheckFlag = false;
      this.bankID = this.invoiceCheckList[0].bankId;
      this.bankName = this.invoiceCheckList[0].bankName;
      this.chequeNo = this.invoiceCheckList[0].chequeNo;
      this.payChequePaid = this.invoiceCheckList[0].paymentStatus == '2' ? true : false;
      this.payChequeUnPaid = this.invoiceCheckList[0].paymentStatus != '2' ? true : false;
      this.invoiceCheckList[0]['uploadContents'] = this.invoiceCheckList[0].uploadContents != undefined ? this.invoiceCheckList[0].uploadContents : [];
      this.invoiceCheckList[0]['attachments'] = this.invoiceCheckList[0].uploadContents;
      this.invoiceCheckList[0]['attachmentItems'] = this.invoiceCheckList[0].uploadContents;
      this.attachmentItems = this.invoiceCheckList[0]['attachmentItems'];
      this.invoiceCheckList[0]['attachmentLoading'] = this.invoiceCheckList[0].uploadContents.length > 0 ? false : true;
      this.invoiceCheckList[0]['EditAttachmentAction'] = 'attachments';
      this.saveROchequeFlag = false;
    }
    if(this.invoiceCashList && this.invoiceCashList.length>0){
      this.payCash = true;      
      this.paymentInvoiceCheckFlag = false;
      this.payChequePaid = this.invoiceCashList[0].paymentStatus == '2' ? true : false;
      this.payChequeUnPaid = this.invoiceCashList[0].paymentStatus != '2' ? true : false;
      this.saveROchequeFlag = false;
    }
    if(this.invoiceonAccList && this.invoiceonAccList.length>0){
      this.payAccount = true;
      this.paymentInvoiceCheckFlag = false;
      this.payChequePaid = this.invoiceonAccList[0].paymentStatus == '2' ? true : false;
      this.payChequeUnPaid = this.invoiceonAccList[0].paymentStatus != '2' ? true : false;
      this.paymentDays = this.invoiceonAccList[0].onAccountDays;
      this.saveROchequeFlag = this.paymentDays == '' ? true : false;
    }
    if(this.invoiceCardList && this.invoiceCardList.length>0){
      this.payCard = true;
      this.paymentInvoiceCheckFlag = false;
      this.payChequePaid = this.invoiceCardList[0].paymentStatus == '2' ? true : false;
      this.payChequeUnPaid = this.invoiceCardList[0].paymentStatus != '2' ? true : false;
      this.saveROchequeFlag = this.cardShow && this.cardShow.length>0 ? false : true;
    }
    if(this.invoiceOtherAccList && this.invoiceOtherAccList.length>0){
      this.payOtherAccount = true;
      this.paymentInvoiceCheckFlag = false;
      this.payChequePaid = this.invoiceOtherAccList[0].paymentStatus == '2' ? true : false;
      this.payChequeUnPaid = this.invoiceOtherAccList[0].paymentStatus != '2' ? true : false;
      this.filteredOtherPaymentIds=[];
      this.filteredOtherPayments=[];
      this.filteredOtherPaymentIds.push(this.invoiceOtherAccList[0].otherPaymentOptionId);
      this.filteredOtherPayments.push(this.invoiceOtherAccList[0].otherPaymentOptionName);   
      this.saveROchequeFlag = this.filteredOtherPaymentIds && this.filteredOtherPaymentIds.length>0 ? false : true;
    }

  }
  changeDD(event){
    console.log(event);
    //this.saveROchequeFlag = this.bankID == ''  || this.chequeNo =='' ? true : false;
  }
  isNumberKey(key){  
    var keycode = (key.which) ? key.which : key.keyCode;
    if (keycode != 46 && keycode > 31
      && (keycode < 48 || keycode > 57))
      return false;     
  }


  getPaymentMethods(type='') {
    
    let shopId = this.shopId;
    const apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      userId: this.userId,
      shopId,
      access: 'ro-shop'
    };
  
    this.LandingpagewidgetsAPI.apiWorkOrderPaymentMethods(apiInfo).subscribe((response) => {
      let responseData = response.data;
      let paymentMehods = responseData.items;
      let checkCheckedFlag = 0;
      if(paymentMehods && paymentMehods.length>0){
      console.log(responseData);      
      console.log(paymentMehods);       
      let loadapi = false;
      let loadCardAPI = false;
      this.paymentMehodsFlag = false;
      paymentMehods.forEach(pitem => {   
        switch (pitem.name) {
            case 'Check':
              this.showCheckMethod = pitem.checked;              
              if(this.showCheckMethod){
                checkCheckedFlag++;
                loadapi = true;
                this.showBankData();
              }
            break;
            case 'Cash':
              this.showCashMethod = pitem.checked;
              if(this.showCashMethod){
                checkCheckedFlag++;
                 loadapi = true;
              }
            break;
            case 'Credit Card':
              this.showCardMethod = pitem.checked; 
              if(this.showCardMethod){
                checkCheckedFlag++;
              }            
              this.showCardItemData = pitem.itemData;  
              this.cardShow = pitem.itemData.cards;              
              loadCardAPI = false;
              this.invoiceCardList = []; 
              if(this.stripeInfoJsonArr && this.stripeInfoJsonArr.length>0 && this.paymentInfoJsonArr && this.paymentInfoJsonArr.length>0){
                this.invoiceCardList = this.paymentInfoJsonArr;

                let tdate = this.invoiceCardList[0].transactionDate;
                tdate = moment.utc(tdate).toDate();
                let tdate1 = moment(tdate).local().format('MM/DD/YYYY h:mm:ss A');
                let tdate2 = moment(tdate).local().format('MMM DD, YYYY h:mm A');

                this.invoiceCardList[0].transactionDatePOPUP = tdate1;
                this.invoiceCardList[0].transactionDate = tdate2;

                loadCardAPI = true;
              }                            
            break;
            case 'Open Account':
              this.showAccountMethod = pitem.checked;
              if(this.showAccountMethod){
                loadapi = true;
                checkCheckedFlag++;
              }
              let itemData = pitem.itemData.items; 
              console.log(pitem.itemData);
              console.log(pitem.itemData.items);
              itemData.forEach(itemDa => {
                if(itemDa.checked){
                    this.paymentDays = itemDa.name;                    
                }
              });   
            break;
            case 'Other':
              this.showOtherMethod = pitem.checked;
              if(this.showOtherMethod){
                loadapi = true;
                checkCheckedFlag++;
              }
            break;
        }       
      }); 
      setTimeout(() => {
         if(loadCardAPI){                
          loadapi = false;
          this.loading = false;
          let paymentStatus = 'paid';
          let invoiceType = this.invoiceCardList[0].invoiceType != undefined && this.invoiceCardList[0].invoiceType != '' ? this.invoiceCardList[0].invoiceType : 'Price Invoice';
          let dataObj = {
            paymentStatus :paymentStatus,
            invoiceType: invoiceType
          }
          this.callbackROEInvoice.emit(dataObj);
          this.paymentInvoiceCheckFlag = true;  
          this.payInvoiceFlag = false;  
          this.totalInvoice = this.estimationTotal;  
          this.totalInvoice = Math.abs(this.totalInvoice).toFixed(2);       
          this.estimateActionTypeFlag = true;
        }       
        if(loadapi){
          this.loadInvoiceDetails(type);
        }
        if(!loadCardAPI && !loadapi){
          this.showOneMethod();       
        }        
        if(checkCheckedFlag==0){
          this.loading = false;
          this.paymentMehodsFlag = true;
          let dataObj = {
            action: 'empty'
          };
          this.callbackROEInvoice.emit(dataObj);
        }
      }, 100);
     
    }
     else{
      this.loading = false;
      this.paymentMehodsFlag = true;
      let dataObj = {
        action: 'empty'
      };
      this.callbackROEInvoice.emit(dataObj);
    }
    });
  
  }

  estimateActionChange(){
    if(!this.estimateActionTypeFlag){
      this.totalInvoice = this.estimateActionType == 'retail' ? this.estimationTotal : this.wdestimationTotal;
      this.totalInvoice = Math.abs(this.totalInvoice).toFixed(2);
    }
    else{

    }
  }

  
  stripeInvoicdCardCallBack(data) {
    console.log(data);
    if(data){
      this.getPaymentMethods("card");      
    }
  }

  saveCardPayInvoice(){

    

    if(this.payCard){
      this.saveROchequeFlag = this.cardShow && this.cardShow.length>0 ? false : true;
      if(!this.saveROchequeFlag){
        this.payButtonShow = true;
      }            
    }
    if(!this.saveROchequeFlag && this.payButtonShow){
      //this.invoiceID = this.invoiceID == 0 ? this.roId : this.invoiceID;
      this.invoiceID = this.roId;
      this.paymentLoading = true;  
      this.payButtonShow = false;
      let formData = new FormData;
      formData.append('apiKey', Constant.ApiKey);
      formData.append('userId', this.userId);
      formData.append('domainId', this.domainId);
      formData.append('roId', this.roId); 
      formData.append('estimateId', this.estimateId);       
      /*new Response(formData).text().then(console.log);
      return false;*/         
      this.commonApi.saveROCardPayment(formData).subscribe((response) => {  
        this.paymentLoading = false;
        if(response.status == 'Success'){ 
            console.log(response);
            this.paymentSuccessPopup = true;              
            this.paymentSuccessText1 = response.data.transactionId != undefined ? response.data.transactionId : this.paymentSuccessText1;
            this.paymentSuccessText2 = this.invoiceID;
            this.paymentSuccessText3 = response.data.cbtTransactionId;
            this.paymentSuccessText4 = response.data.paymentInfo.amount;
            this.paymentSuccessText5 = response.data.email;            
            this.showTempList(response.data);
            this.payChequeOption('1');
            this.saveROcheque();
            this.callCloseThreadAPI(); 
        }
        else{
           this.payChequeOption('0');
           this.saveROcheque();
           this.paymentFailurePopup = true;
           this.paymentMessage = response.message;
        }
      }, (error: any) => {
        this.paymentFailurePopup = true;
        this.paymentLoading = false;
        this.paymentMessage = error.message;
        console.log(error)
      });
    }
  }

  showTempList(data){
    this.stripeInfoJsonArr.push({
      cardBrand:data.paymentInfo.cardInfo.cardType,      
      cardNumber:data.cardNumber,      
    });

    this.paymentInfoJsonArr.push(data.paymentInfo);

    if(this.stripeInfoJsonArr && this.stripeInfoJsonArr.length>0 && this.paymentInfoJsonArr && this.paymentInfoJsonArr.length>0){
        this.invoiceCardList = this.paymentInfoJsonArr;

        let tdate = this.invoiceCardList[0].transactionDate;
        tdate = moment.utc(tdate).toDate();
        let tdate1 = moment(tdate).local().format('MM/DD/YYYY h:mm:ss A');
        let tdate2 = moment(tdate).local().format('MMM DD, YYYY h:mm A');

        this.invoiceCardList[0].transactionDatePOPUP = tdate1;
        this.invoiceCardList[0].transactionDate = tdate2;

        this.paymentInvoiceCheckFlag = true;  
        this.payInvoiceFlag = false;  
        this.totalInvoice = this.estimationTotal;  
        this.totalInvoice = Math.abs(this.totalInvoice).toFixed(2);       
        this.estimateActionTypeFlag = true;

    }

    let paymentStatus = 'paid';
    let invoiceType = this.invoiceCardList[0].invoiceType != undefined && this.invoiceCardList[0].invoiceType != '' ? this.invoiceCardList[0].invoiceType : 'Price Invoice';
    let dataObj = {
      paymentStatus :paymentStatus,
      invoiceType: invoiceType
    }
    this.callbackROEInvoice.emit(dataObj);

  }

  saveCardPayInvoiceCancel(){
    
  }

  closePopup(){
    this.paymentFailurePopup = false;
    this.saveROchequeFlag = this.cardShow && this.cardShow.length>0 ? false : true;
  }
  successClose(){
    this.paymentSuccessPopup = false;       
  }

  tryAgain(){
    this.paymentFailurePopup = false;
    this.saveROchequeFlag = true;
    this.saveCardPayInvoice();
  }

  openCardDetailPOPUP(){
    this.viewCardDetailPOPUP = true;
  }

  receiptURL(){
    let url = this.invoiceCardList && this.invoiceCardList.length>0 ? this.invoiceCardList[0].receiptUrl : ''; 
    if(url!=''){
    window.open(url,url);
    }
  }


  callCloseThreadAPI(){
    if(this.payChequePaid){
      if(this.dispatchId > 0) {
          this.changeDispatchStatus(this.dispatchId, 4);
        }
        if(this.threadId>0){
          this.closeThread(this.threadId);
          this.threadSilentPush(this.threadId);
          this.changeRoStatus(); 
        }
        else{
          this.changeRoStatus();  
        }
        let dataObj = {
          action :'payment-status',
          paymentStatus: 'paid'
        }
        this.callbackROPayStatus.emit(dataObj);     
      }
  }

  changeRoStatus() {
    let timeout = (this.threadId > 0) ? 1000 : 0;
    if(this.payChequePaid){
      let platform: any = 3;
      let apiDatasocial = new FormData();
      apiDatasocial.append('apiKey', Constant.ApiKey);
      apiDatasocial.append('domainId', this.domainId);               
      apiDatasocial.append('userId', this.userId);
      apiDatasocial.append('id', this.roId);          
      apiDatasocial.append('statusId', '13');
      apiDatasocial.append('platform', platform);
      this.repairOrderApi.changeStatusTicket(apiDatasocial).subscribe(res => {
        setTimeout(() => {      
          let action = 'update';
          let actionType = SolrContentTypeValues.repairOrder;
          this.updateSolr(action, actionType, this.roId);
        }, timeout);      
      });
    }
    else{
        setTimeout(() => {      
          let action = 'update';
          let actionType = SolrContentTypeValues.repairOrder;
          this.updateSolr(action, actionType, this.roId);
        }, timeout);
    }
    
  }

  
  closeThread(threadId) {
    let capiData = new FormData();
    capiData.append('apiKey', Constant.ApiKey);
    capiData.append('domainId', this.domainId);
    capiData.append('countryId', this.countryId);
    capiData.append('userId', this.userId);
    capiData.append('threadId', threadId);
    capiData.append('closeStatus', 'yes');
    capiData.append('emailFlag', '1');
    capiData.append('platform', '3');
    this.threadPostService.closeThread(capiData).subscribe(response => {
      let taction = 'update';
      let tactionType = SolrContentTypeValues.Thread;
      this.updateSolr(taction, tactionType, threadId);
    });
  }

  threadSilentPush(threadId) {
    let apiData = new FormData();
    apiData.append('apiKey', Constant.ApiKey);
    apiData.append('domainId', this.domainId);
    apiData.append('userId', this.userId);
    apiData.append('threadId', threadId);
    apiData.append('silentPush', '1');
    apiData.append('action', 'close');
    this.threadPostService.sendPushtoMobileAPI(apiData).subscribe((response) => {});
  }

  updateSolr(action, actionType, dataId, postId = '') {
    let apiDatasocial = new FormData();
    apiDatasocial.append('apiKey', Constant.ApiKey);
    apiDatasocial.append('domainId', this.domainId);
    apiDatasocial.append('userId', this.userId);
    apiDatasocial.append('action', action);
    apiDatasocial.append('actionType', actionType);
    switch (actionType) {
      case 1:
        apiDatasocial.append('threadId', dataId);
        if(postId != '') {
          apiDatasocial.append('postId', postId);
        }
        break;
      case 7:
        apiDatasocial.append('workOrderId', this.roId);
        break;
      case 16:
        apiDatasocial.append('threadId', dataId);
        break;
    }
    this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { });
  }

  onChangeSelection(field){

    let apiData = {
      'apiKey': Constant.ApiKey,
      'domainId': this.domainId,
      'countryId': this.countryId,
      'userId': this.userId,
    };
    let inputData = {}
    switch(field){
      case 'other-payment':
        inputData = {
          baseApiUrl: this.collabticApi,
          apiUrl: this.collabticApi+""+Constant.otherpaymentListApiUrl,
          field: field,
          selectionType: "single",
          filteredItems: this.filteredOtherPaymentIds,
          filteredLists: this.filteredOtherPayments,
          actionApiName: Constant.otherpaymentctionApiUrl,
          actionQueryValues: "",
          title: "Other Payment Option"
        };
      break;
    }    
    console.log(inputData);
    const modalRef = this.modalService.open(ManageListComponent, {backdrop: 'static', keyboard: false, centered: true, size: 'max-width-650'});
    modalRef.componentInstance.accessAction = true;
    modalRef.componentInstance.apiData = apiData;
    modalRef.componentInstance.height = innerHeight - 140;    
    modalRef.componentInstance.access = "newthread";
    modalRef.componentInstance.pageType = "ro-invoice";    
    modalRef.componentInstance.filteredTags = this.filteredOtherPaymentIds;
    modalRef.componentInstance.filteredLists = this.filteredOtherPayments;
    modalRef.componentInstance.inputData = inputData;
      modalRef.componentInstance.selectedItems.subscribe((receivedService) => {
        //modalRef.dismiss('Cross click');
        let tagItems = receivedService;
        let flag = false;
        switch(field){
          case 'other-payment':
            flag =
          JSON.stringify(this.filteredOtherPaymentIds) == JSON.stringify(tagItems)
            ? false
            : true;
        if (flag) {
          this.filteredOtherPaymentIds = [];
          this.filteredOtherPayments = [];
          for (let t in tagItems) {
            let tadId = tagItems[t].id;
            let tagName = tagItems[t].name;
            let chkIndex = this.filteredOtherPaymentIds.findIndex(
              (option) => option == tadId
            );
            if (chkIndex < 0) {

              this.filteredOtherPaymentIds = [];
              this.filteredOtherPayments = [];

              this.filteredOtherPaymentIds.push(tadId);
              this.filteredOtherPayments.push(tagName);
              this.saveROchequeFlag = false;
            }
          }

        }
          break;
          
        }
        
      });
  
  }

    // Disable Tag Selection
  disableOtherPaymentSelection(index) {
    this.filteredOtherPaymentIds.splice(index, 1);
    this.filteredOtherPayments.splice(index, 1);
  }

  changeDispatchStatus(dispatchId, statusId) {
  const apiInfo = {
    apikey: Constant.ApiKey,
    countryId: this.countryId,
    domainId: this.domainId,
    userId: this.userId,
    action: 'change',
    serviceId: dispatchId,
    statusId,
    fieldId: statusId,
    field:'status',
    platform: '3'
  };
  this.LandingpagewidgetsAPI.manageServiceAPI(apiInfo).subscribe(response => {});

  }

  navPaymentSettings() {
    let url = 'system-settings/payment-types';
    let navHome = window.open(url, url);
    navHome.focus();
  }

}




       
      
